import { IProductVariant } from '../interfaces/product'
import api from './api'

const hatDetails: IProductVariant = {
    rotation: 0,
    alpha: 1,
    images: [
        {
            url: '/images/h-w.jpg',
            color: 'white',
        },
        {
            url: '/images/h-k.jpg',
            color: 'black',
        },
        {
            url: '/images/h-r.jpg',
            color: 'red',
        },
        {
            url: '/images/h-g.jpg',
            color: 'green',
        },
        {
            url: '/images/h-b.jpg',
            color: 'blue',
        },
        {
            url: '/images/h-y.jpg',
            color: 'yellow',
        },
    ],
    width: 500,
    height: 426,
    designWidth: 60,
    designHeight: 60,
    designX: 270,
    designY: 340,
    snipcart: {
        name: 'Hat',
        price: 9.95,
        description: 'This new luxurious knitted beanie adds a cool, effortless vibe to any winter outfit, yet keeps it elegant due to the high-quality extra-fine merino with cashmere touch. An essential piece to keep you warm and stylish during chillier days. ',
        image: '/images/h-w.jpg',
        id: 'hat',
        url: '/products/hat',
        custom1Name: 'Color',
        custom1Options:'White|Black|Red|Green|Blue|Yellow[+10.00]',
    }
}

const tshirtDetails: IProductVariant = {
    rotation: 0,
    alpha: 1,
    images: [
        {
            url: '/images/t-w.jpg',
            color: 'white',
        },
        {
            url: '/images/t-k.jpg',
            color: 'black',
        },
        {
            url: '/images/t-r.jpg',
            color: 'red',
        },
        {
            url: '/images/t-g.jpg',
            color: 'green',
        },
        {
            url: '/images/t-b.jpg',
            color: 'blue',
        },
        {
            url: '/images/t-y.jpg',
            color: 'yellow',
        },
    ],
    width: 500,
    height: 500,
    designWidth: 200,
    designHeight: 200,
    designX: 200,
    designY: 160,
    snipcart: {
        name: 'Tshirt',
        price: 29.95,
        description: 'High-tech cross sports T-shirt with crewneck collar that slightly stands up. Hide your keys or card in the functional zipped side pocket.',
        image: '/images/t-w.jpg',
        id: 'tshirt',
        url: '/products/tshirt',
        custom1Name: 'Color',
        custom1Options:'White|Black|Red|Green|Blue|Yellow',
    }
}

const bagDetails: IProductVariant = {
    rotation: 0,
    alpha: 1,
    images: [
        {
            url: '/images/b-w.jpg',
            color: 'white',
        },
        {
            url: '/images/b-k.jpg',
            color: 'black',
        },
        {
            url: '/images/b-r.jpg',
            color: 'red',
        },
        {
            url: '/images/b-g.jpg',
            color: 'green',
        },
        {
            url: '/images/b-b.jpg',
            color: 'blue',
        },
        {
            url: '/images/b-y.jpg',
            color: 'yellow',
        },
    ],
    width: 500,
    height: 500,
    designWidth: 200,
    designHeight: 200,
    designX: 196,
    designY: 320,
    snipcart: {
        name: 'Bag',
        price: 19.95,
        description: 'Tote bag with long handles printed with logo. This carrier bag is made of 80gr/m2 non-woven material. The bag has long handles and is available in different colors.',
        image: '/images/b-w.jpg',
        id: 'bag',
        url: '/products/bag',
        custom1Name: 'Color',
        custom1Options:'White|Black[-1.00]|Red|Green|Blue|Yellow',
    }
}

const keysDetails: IProductVariant = {
    rotation: 0,
    alpha: 1,
    images: [
        {
            url: '/images/keys-1.jpg',
            color: 'white',
        },
        
    ],
    mask: '/images/keys-1.png',
    width: 500,
    height: 500,
    designWidth: 122,
    designHeight: 122,
    designX: 196,
    designY: 320,
    snipcart: {
        name: 'Keychain',
        price: 10.14,
        description: 'Tote bag with long handles printed with logo. This carrier bag is made of 80gr/m2 non-woven material. The bag has long handles and is available in different colors.',
        image: '/images/keys-1.jpg',
        id: 'keys',
        url: '/products/keys',
        custom1Name: 'Color',
        custom1Options:'White|Black[-1.00]|Red|Green|Blue|Yellow',
    }
}
export default {
    get() {
        
        return api.get('/api/products')
    }

}